import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define a type for the slice state

export const generatedLetterSlice = createSlice({
  name: "generatedLetter",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: [],
  reducers: {
    setGeneratedLetter: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state = payload;
    },
    resetGeneratedLetter: (state: any, action: PayloadAction<any>) => {
      state = [];
    },
  },
});

export const { setGeneratedLetter, resetGeneratedLetter } =
  generatedLetterSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default generatedLetterSlice.reducer;
